import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[multiple-template]',
})
export class MultipleTemplateDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
